import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["input", "clearButton"]
  static values = { 
    param: { type: String, default: "q" },
    delay: { type: Number, default: 250 },
    turbo: { type: Boolean, default: true },
    submitOnEnter: { type: Boolean, default: false },
    resetPagination: { type: Boolean, default: true },
    frame: { type: String, default: null },
    url: { type: String, default: null }
  }

  connect() {
    this.timeout = null

    this.toggleClearButton()
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  update(event) {
    if (event.type === "keyup" && event.key === "Enter") {
      event.preventDefault()
      this.performSearch()
      return
    }

    this.toggleClearButton()

    if (this.submitOnEnterValue) {
      return
    }

    this.scheduleSearch()
  }

  scheduleSearch() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.performSearch(), this.delayValue)
  }

  performSearch() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    const term = this.hasInputTarget ? this.inputTarget.value.trim() : ""
    const baseUrl = this.urlValue || window.location.pathname
    const paramName = this.paramValue

    if (this.frameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        let nextUrl = baseUrl
        if (term !== "") {
          const params = new URLSearchParams()
          params.set(paramName, term)
          nextUrl = `${baseUrl}?${params.toString()}`
        }

        frame.innerHTML = this.loadingMarkup()
        frame.setAttribute("src", nextUrl)
        return
      }
    }

    let nextUrl = baseUrl
    if (term !== "") {
      const params = new URLSearchParams()
      params.set(paramName, term)
      if (this.resetPaginationValue) {
        params.delete("page")
      }
      nextUrl = `${baseUrl}?${params.toString()}`
    }

    if (this.turboValue && window.Turbo) {
      window.Turbo.visit(nextUrl, { action: "replace" })
    } else {
      window.location.assign(nextUrl)
    }
  }

  clearSearch(event) {
    this.clearInput(event)
  }

  clear(event) {
    this.clearInput(event)
  }

  clearInput(event) {
    event?.preventDefault()
    if (!this.hasInputTarget) return
    this.inputTarget.value = ""
    this.toggleClearButton()
    this.performSearch()
  }

  toggleClearButton() {
    if (!this.hasClearButtonTarget || !this.hasInputTarget) return
    const hasValue = this.inputTarget.value.trim() !== ""
    this.clearButtonTarget.classList.toggle("d-none", !hasValue)
  }

  loadingMarkup() {
    return `
      <div class="py-4 text-center text-muted small">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading…</span>
        </div>
        <span class="d-block mt-2">Loading results…</span>
      </div>
    `
  }
} 